import api from "../../../utils/api";

export const getProgramTypes = async () => {
  return (await api.get("/Academics/GetAllProgramTypesAsync"))
    // eslint-disable-next-line no-undef
    ?.data as ProgramTypeResponse;
};

export const getAllModeOfStudy = async () => {
  return (await api.get("/Utilities/Utilities/GetAllModeOfStudy"))
    ?.data as ModeOfStudyResponse;
};
